export default __webpack_public_path__ + "static/media/rm_logo_black_coop.9ded4a84.svg";